import { IConsentMgmtForm } from "../../models/models";
import * as yup from "yup";

export const CONSENT_MGMT_INITIAL_VALUE: IConsentMgmtForm = {
    consents: {
        extendedPromotionsAgree: false,
        extendedPromotionsDisagree: false,
        extendedPromotionsChannels: [],
        relatedPromotionsAgree: false,
        relatedPromotionsDisagree: false,
        relatedPromotionsChannels: [],
        commercialPromotionsAgree: false,
        commercialPromotionsDisagree: false,
        commercialPromotionsChannels: [],
        acknowledgmentChannels: [],
        file: null
    },
    acknowledgment: false,
}

export const CONSENT_MGMT_VALIDATION_SCHEMA = yup.object().shape({
    consents: yup.object().shape({
        extendedPromotionsAgree: yup.boolean()
            .test({
                name: 'extendedPromotionsAgree',
                message: "common.error.required",
                test(value, context) {
                    return !!value || !!context.parent.extendedPromotionsDisagree;
                }
            }),
        extendedPromotionsDisagree: yup.boolean()
            .test({
                name: 'extendedPromotionsDisagree',
                message: "common.error.required",
                test(value, context) {
                    return !!value || !!context.parent.extendedPromotionsAgree;
                }
            }),
        extendedPromotionsChannels: yup.array().of(yup.string())
            .test({
                name: "extendedPromotionsChannelsRequired",
                message: "consentMgmt.consentsSection.validation.selectAtLeastOne",
                test(value, context) {
                    if (context.parent.extendedPromotionsAgree) {
                        return Array.isArray(value) && value.length > 0;
                    }
                    return true;
                }
            }),
        relatedPromotionsAgree: yup.boolean()
            .test({
                name: 'relatedPromotionsAgree',
                message: "common.error.required",
                test(value, context) {
                    return !!value || !!context.parent.relatedPromotionsDisagree;
                }
            }),
        relatedPromotionsDisagree: yup.boolean()
            .test({
                name: 'relatedPromotionsDisagree',
                message: "common.error.required",
                test(value, context) {
                    return !!value || !!context.parent.relatedPromotionsAgree;
                }
            }),
        relatedPromotionsChannels: yup.array().of(yup.string())
            .test({
                name: "relatedPromotionsChannelsRequired",
                message: "consentMgmt.consentsSection.validation.selectAtLeastOne",
                test(value, context) {
                    if (context.parent.relatedPromotionsAgree) {
                        return Array.isArray(value) && value.length > 0;
                    }
                    return true;
                }
            }),
        commercialPromotionsAgree: yup.boolean()
            .test({
                name: 'commercialPromotionsAgree',
                message: "common.error.required",
                test(value, context) {
                    return !!value || !!context.parent.commercialPromotionsDisagree;
                }
            }),
        commercialPromotionsDisagree: yup.boolean()
            .test({
                name: 'commercialPromotionsDisagree',
                message: "common.error.required",
                test(value, context) {
                    return !!value || !!context.parent.commercialPromotionsAgree;
                }
            }),
        commercialPromotionsChannels: yup.array().of(yup.string())
            .test({
                name: "commercialPromotionsChannelsRequired",
                message: "consentMgmt.consentsSection.validation.selectAtLeastOne",
                test(value, context) {
                    if (context.parent.commercialPromotionsAgree) {
                        return Array.isArray(value) && value.length > 0;
                    }
                    return true;
                }
            }),
        file: yup
            .mixed()
            .nullable()
            .required("common.error.required")
    }),
    acknowledgment: yup.boolean()
        .test({
            name: 'acknowledgment',
            message: "common.error.required",
            test(value) {
                return !!value;
            }
        })
});
